import { Component, Input } from '@angular/core';

@Component({
    selector: 'parenthetical-currency',
    template: `
        @if (value >= 0) {
          <span>{{value | currency: 'USD':'symbol-narrow'}}</span>
        }
        @if (value < 0) {
          <span>({{math.abs(value) | currency: 'USD':'symbol-narrow'}})</span>
        }
        `,
    standalone: false
})
export class ParentheticalCurrencyComponent {
    @Input() value: number;
    math = Math;
}
